import { render, staticRenderFns } from "./formsList.vue?vue&type=template&id=6f6c1b16&scoped=true"
import script from "./formsList.vue?vue&type=script&lang=js"
export * from "./formsList.vue?vue&type=script&lang=js"
import style0 from "./formsList.vue?vue&type=style&index=0&id=6f6c1b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6c1b16",
  null
  
)

export default component.exports